import React from "react";
import { Form, Input } from "antd";
import PropTypes from "prop-types";

const { TextArea } = Input;

const TextAreaInput = ({ rules = [], label, name, onChange, inputProps }) => {
  const [isRequired, setIsRequired] = React.useState(false);

  React.useEffect(() => {
    if (rules && rules.length && !isRequired) {
      setIsRequired(rules.find((item) => item.required === true));
    }
  }, [rules, isRequired]);

  const handlerChange = (value) => {
    onChange && onChange(value);
  };

  return (
    <Form.Item
      key={name}
      label={<span style={{ textTransform: "capitalize" }}>{label}</span>}
      required={isRequired}
      name={name}
      rules={rules}
    >
      <TextArea
        rows={4}
        onChange={handlerChange}
        placeholder={label}
        {...inputProps}
      />
    </Form.Item>
  );
};

TextAreaInput.propTypes = {
  rules: PropTypes.arrayOf(PropTypes.any),
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  inputProps: PropTypes.any,
};

export default TextAreaInput;
